/**
 * MentionDropdown — combobox rendered below an input/textarea showing
 * autocomplete matches for the active `@query`.
 */

import React from 'react';
import { MentionMatch, MentionProvider } from '../registry';

export interface MentionDropdownProps {
  matches: Array<{ provider: MentionProvider; match: MentionMatch }>;
  activeIndex: number;
  loading: boolean;
  onSelect: (index: number) => void;
  onHoverIndex: (index: number) => void;
}

export function MentionDropdown({
  matches,
  activeIndex,
  loading,
  onSelect,
  onHoverIndex,
}: MentionDropdownProps) {
  if (loading && matches.length === 0) {
    return (
      <div className="mention-dropdown">
        <div className="mention-dropdown__empty">Searching…</div>
      </div>
    );
  }
  if (matches.length === 0) {
    return (
      <div className="mention-dropdown">
        <div className="mention-dropdown__empty">No matches</div>
      </div>
    );
  }
  return (
    <div className="mention-dropdown" role="listbox">
      {matches.map(({ provider, match }, i) => {
        const isActive = i === activeIndex;
        return (
          <button
            key={`${provider.kind}:${match.id}`}
            type="button"
            role="option"
            aria-selected={isActive}
            className={`mention-dropdown__item${isActive ? ' mention-dropdown__item--active' : ''}`}
            onMouseDown={(e) => {
              // Prevent the input from losing focus before onSelect fires.
              e.preventDefault();
              onSelect(i);
            }}
            onMouseEnter={() => onHoverIndex(i)}
          >
            <span className="mention-dropdown__label">@{match.label}</span>
            {match.hint && (
              <span className="mention-dropdown__hint">{match.hint}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
